export default {"src":"/pro/_next/static/media/pepe.794b1126.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};